import * as React from 'react';

import { MiniCalendarState, MiniCalendarProps } from './container';
import { MiniCalendarControlsView, MiniCalendarControlsViewProps } from './controls.view';
import { MiniCalendarGridView, MiniCalendarGridViewProps } from './grid.view';
import { MiniCalendarFooterView, MiniCalendarFooterViewProps } from './footer.view';

export interface MiniCalendarContainerViewProps extends MiniCalendarProps, MiniCalendarState {
    controlsProps: MiniCalendarControlsViewProps;
    gridProps: MiniCalendarGridViewProps;
    footerProps: MiniCalendarFooterViewProps;

    firstRef: React.RefObject<HTMLDivElement>;

    closeMiniCalDialog: () => void;
    handleKeyDown: (e: React.KeyboardEvent) => void;
}

/**
 * Displays the mini-calendar in different contexts depending on window size.
 */
const MiniCalendarContainerView: React.FunctionComponent<MiniCalendarContainerViewProps> = props => {

    return (
        <div className="mini-cal-column grid-col">
            {
                props.useModal
                    ? <div className="modal-wrapper mini-cal-modal" onKeyDown={props.handleKeyDown}>
                        <div data-modal className="modal-container" aria-hidden={!props.miniCalDialogOpen}>
                            <div tabIndex={-1} data-a11y-dialog-hide ref={props.firstRef} className="modal-overlay" onClick={props.closeMiniCalDialog} />
                            <div role="dialog" aria-labelledby="calModalTitle" className="modal-dialog">
                                <div className="modal-inner">
                                    <div className="modal-header">
                                        <h1 className="h3-style" id="calModalTitle">Jump to Month</h1>
                                        <button type="button" data-a11y-dialog-hide aria-label="Close this dialog" className="modal-close x-btn" onClick={props.closeMiniCalDialog}></button>
                                    </div>

                                    <div className="mini-cal-nav">
                                        <nav className="mini-cal-modal-inner" aria-labelledby="MiniCal_Heading">
                                            <MiniCalendarControlsView {...props.controlsProps} />
                                            <MiniCalendarGridView {...props.gridProps} />
                                            {/*<MiniCalendarFooterView {...props.footerProps} />*/}
                                        </nav>

                                        <button type="button" data-a11y-dialog-hide aria-label="Close this dialog" className="modal-close btn" onClick={props.closeMiniCalDialog}>Done</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <div className="mini-cal-nav">
                        <nav className="mini-cal-container" aria-labelledby="MiniCal_Heading">
                            <MiniCalendarControlsView {...props.controlsProps} />
                            <MiniCalendarGridView {...props.gridProps} />
                            {/*<MiniCalendarFooterView {...props.footerProps} />*/}
                        </nav>
                    </div>
            }
        </div>
    )
}

export default MiniCalendarContainerView;